//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
    Fragment,
    useState,
    useEffect,
    useContext,
    useCallback,
  } from "react";
  import access from "config/access";
  import { toast } from "react-toastify";
  import * as moment from "moment";
  import { parseISO } from "date-fns";
  import { blockInvalidChar } from "helpers/blockInvalidChar";
  import { CSVLink } from "react-csv";
  import { useHistory } from "react-router-dom";
  
  // custom pages
  import Table from "components/Table/Table";
  import UnconsentedMemberAccountsAPI from "apis/unconsentedMemberAccounts/unconsentedMemberAccounts";
  import Context from "context/context";
  import searchIcon from "assets/img/Search_Icon.png";
  import { Styles } from "./styles";
  import useDebounce from "helpers/useDebounce";
  import { blockInvalidCharForText } from "helpers/blockInvalidCharForText";
  import CircularProgress from "@material-ui/core/CircularProgress";
  import AuditAPI from "apis/audit/audit";
  import HistoryTable from "components/Table/History/HistoryTable";
  import Loader from "components/Loader/Loader";
  import { exportHeaders } from "./export";
  
  // material-ui
  import TextField from "@material-ui/core/TextField";
  import { withStyles } from "@material-ui/core/styles";
  import InputAdornment from "@material-ui/core/InputAdornment";
  import Switch from "@material-ui/core/Switch";
  import FormControlLabel from "@material-ui/core/FormControlLabel";
  import Dialog from "@material-ui/core/Dialog";
  import Button from "@material-ui/core/Button";
  import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from "@material-ui/pickers";
  import DateFnsUtils from "@date-io/date-fns";
  import MenuItem from "@material-ui/core/MenuItem";
  import Card from "@material-ui/core/Card";
  import Badge from "@material-ui/core/Badge";
  
  // material-ui icons
  import Grid from "@material-ui/core/Grid";
  import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
  import EditIcon from "@material-ui/icons/Edit";
  import { isBefore } from "date-fns";
  import HistoryIcon from "@material-ui/icons/History";
  import HighlightOffIcon from "@material-ui/icons/HighlightOff";
  
  // custom TextField
  const CssTextField = withStyles({
    root: {
      "& label.Mui-focused": {
        color: "##D3D3D3",
      },
      "& .MuiFormLabel-root": {
        color: "#707070",
      },
      "& .MuiInputBase-input": {
        color: "#707070",
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: "#707070!important",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "#707070!important",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#707070",
        },
        "&:hover fieldset": {
          borderColor: "#707070",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#707070",
        },
        "&.MuiOutlinedInput-root": {
          borderRadius: 20,
        },
        "&.MuiOutlinedInput-root": {
          marginTop: 0,
          borderRadius: 20,
          background: "#ededed",
        },
      },
    },
  })(TextField);
  
  const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      "&$checked": {
        transform: "translateX(16px)",
        color: theme.palette.common.white,
        "& + $track": {
          backgroundColor: "#2F7CBD",
          opacity: 1,
          border: "none",
        },
      },
      "&$focusVisible $thumb": {
        color: "#2F7CBD",
        border: "6px solid #2F7CBD",
      },
    },
    thumb: {
      width: 24,
      height: 24,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid gray`,
      backgroundColor: "gray",
      opacity: 1,
      transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
  });
  
  export default function DeactivatedMemberAccounts() {
    const { getDeactivatedAPI, exportDeactivatedAPI } =
      UnconsentedMemberAccountsAPI();
    const { getAudit } = AuditAPI();
    const { state, dispatch } = useContext(Context);
    const classes = Styles();
    const history = useHistory();
  
    const [data, setData] = useState([]);
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true);
  
    // Extend Deactivation Date
    const [extendDeactivationObj, setExtendDeactivationObj] = useState({
      index: 0,
      loyaltyDetails: {},
      modal: false,
      updateReason: "",
      otherReason: false,
      extendDeactiveDate: moment(new Date()).format("YYYY-MM-DD"),
      type: "",
    });
  
    //Filter
    const [filterObj, setFilterObj] = useState({
      filterCard: false,
      extendedStartDate: null,
      extendedEndDate: null,
      extended: null,
      unconsentedPeriod: null,
      filterActive: false,
    });
  
    // Export Data
    const [exportData, setExportData] = useState([]);
  
    // Common State Object
    const [states, setstates] = useState({
      reasonDescription: [],
      clearSearch: false,
      historyDialog: false,
      historyLoader: false,
      filterCard: false,
      exportLoader:false
    });
  
    const setStates = useCallback((newState) => {
      setstates((states) => ({ ...states, ...newState }));
    }, []);
  
    const { reasonDescription, clearSearch, historyDialog, historyLoader, exportLoader } =
      states;
  
    // Page Path Name
    useEffect(() => {
      dispatch({
        type: "SET_PATHNAME",
        payload: ["HOME", "ADMIN", "MEMBER DETAILS"],
      });
    }, []);
  
    // Handling Get
    useEffect(() => {
      getDetails();
    }, [offset]);
  
    // Get API Func
    async function getDetails() {
      try {
        setLoading(true);
        let values;
        values = {
          offset: (offset - 1) * 10,
          limit: 10,
        };
  
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await getDeactivatedAPI(values);
        if (res) {
          setData(res.data);
          setCount(res.count);
          setLoading(false);
          dispatch({ type: "SET_LOADING", payload: false });
        }
      } catch (e) {
        console.log({ e });
      }
    }
  
    // Data Table Headings
    let tableHeading = [
      "Member ID",
      "Billto",
      "Enrollment / Transfer",
      "Account Created By",
      "Status",
      "Unconsented Days",
      "Extended Date",
      "History",
    ];
  
    // Table Pagination Func
    const handlePagination = (value) => {
      setOffset(value);
    };
  
    const handleGetHistoryData = async (id) => {
      try {
        let values;
        values = {
          recordId: id,
          key: "la",
        };
        let res = await getAudit(values);
        if (res) {
          setStates({ historyData: res?.data, historyLoader: false });
        }
      } catch (e) {
        console.log({ e });
      }
    };
  
    async function handleExport() {
      try {
        let values = {};
  
        dispatch({ type: "SET_LOADING", payload: true });
        let res = await exportDeactivatedAPI(values);
        if (res) {
          setExportData(res.data);
          dispatch({ type: "SET_LOADING", payload: false });
          return true;
        }
        return false;
      } catch (e) {
        console.log({ e });
      }
    }
  
    return (
      <Fragment>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            className={`${classes.deactivatedBackBtn} dash-1-filter-btn`}
            onClick={() => {
              history.goBack();
            }}
          >
            Back
          </Button>
          <Button
            className={`${classes.deactivatedExportBtn} dash-1-filter-btn`}
            onClick={async () => {
              setStates({exportLoader:true})
              let res = await handleExport();
              if (res) {
                document.getElementById("csv").click();
                setStates({exportLoader:false})
              }
            }}
          >
            {exportLoader ? (
              <div style={{ marginLeft:"calc(50%)" }}>
                  <div class="dot-typing-e"></div>
              </div>
            ) :
              `Export`
            }
          </Button>
        </div>
  
        <div style={{ marginTop: 20 }}>
          {!loading ? (
            <Table
              headings={tableHeading.map((i) => {
                return <div>{i}</div>;
              })}
              data={
                data &&
                data.length > 0 &&
                data.map((d, i) => [
                  d?.loyalty_id,
                  d?.customer_billto_account_number,
                  d?.member_account_created_by === 1
                    ? "Enrollment"
                    : d?.member_account_created_by === 2
                    ? "Transfer"
                    : d?.member_account_created_by === 3
                    ? "Manual Enrollment"
                    : d?.member_account_created_by === 4
                    ? "Manual Transfer"
                    : "-",
                  d?.request_by,
                  d?.is_active ? (
                    <span className={classes.greenBtn}>Active</span>
                  ) : (
                    <span className={classes.redBtn}>Deactive</span>
                  ),
                  d?.unconsented_days,
                  d?.deactive_extended_date ? (
                    <span>
                      {moment(d?.deactive_extended_date).format("MM/DD/yyyy")}
                    </span>
                  ) : (
                    "-"
                  ),
  
                  state?.userInfo?.auditAccess && (
                    <HistoryIcon
                      style={{ cursor: "pointer", verticalAlign: "middle" }}
                      onClick={() => {
                        setStates({
                          historyDialog: true,
                          historyLoader: true,
                        });
                        handleGetHistoryData(d?.loyalty_id);
                      }}
                    />
                  ),
                ])
              }
              offset={offset}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
            />
          ) : (
            <div
              style={{
                height: "25vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <h2>Loading...</h2>
            </div>
          )}
        </div>
  
        {/* Audit Logs Dialog */}
        <Dialog
          aria-labelledby="simple-dialog-title"
          open={states.historyDialog}
          style={{ fontFamily: "Segoe-ui" }}
          maxWidth={false}
        >
          <div className={classes.dialogParentDiv}>
            <div
              className={classes.parentText}
              style={{
                paddingBottom: 10,
                width: states?.historyData?.length > 0 ? "100%" : 300,
              }}
            >
              History{" "}
              <span style={{ float: "right" }}>
                <HighlightOffIcon
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontSize: 35,
                  }}
                  onClick={() => {
                    setStates({ historyDialog: false, historyData: [] });
                  }}
                />
              </span>
            </div>
  
            {!historyLoader ? (
              <HistoryTable
                headings={[
                  "Date of Change",
                  "Updated by",
                  "Column Name",
                  "Description",
                  "Reason Code",
                ]}
                data={
                  states?.historyData?.length > 0 &&
                  states?.historyData.map((d, i) => [
                    d?.created_at
                      ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                      : "",
                    `${
                      d?.["User.email"]
                        ? d?.["User.email"]
                        : d?.altered_by
                        ? d?.altered_by.charAt(0).toUpperCase() +
                          d?.altered_by.slice(1).toLowerCase()
                        : "-"
                    }`,
                    d?.column_name,
                    `"${d?.old_value}" changed to "${d?.new_value}"`,
                    d?.reason,
                  ])
                }
                disablePagination={true}
              />
            ) : (
              <div>
                <Loader Loading={historyLoader} top={"15%"}></Loader>
              </div>
            )}
          </div>
        </Dialog>
        <CSVLink
          id="csv"
          data={exportData}
          headers={exportHeaders.map((head) => head)}
          filename={
            `DeactivatedMemberAccounts` +
            " " +
            moment(new Date()).format("MM-DD-YYYY,h:mm A") +
            ".csv"
          }
        />
      </Fragment>
    );
  }